<template>
  <Auth>
    <section>
      <p>Recuperar contraseña</p>
    </section>
    <footer>
    </footer>
  </Auth>
</template>

<script>
import Auth from '@/views/layouts/Auth'
import api  from '@/api'

export default {
  components: { Auth },
  data() {
    return {
    }
  },
  methods: {},
};
</script>
